export default "__VITE_ASSET__DDZDOs69__"